import { Button, Text } from '@southfields-digital/mpxlive-components';

import styles from './RundownSettings.module.scss';
import { LAYOUTS, LayoutType, useRundownLayout } from './useRundownLayout';

type RundownLayoutTogglesProps = {
  onClose: () => void;
  filterLayouts?: (item: LayoutType) => boolean;
};

export function RundownLayoutToggles({ onClose, filterLayouts }: RundownLayoutTogglesProps) {
  const { layout, setLayout } = useRundownLayout();

  const availableLayouts = LAYOUTS.filter((item) => {
    if ((!layout && item.key === 'default') || layout === item.key) return false;
    // If a filter function is provided, delegate visibility decision to it
    return filterLayouts?.(item) ?? true;
  });

  return (
    <>
      {availableLayouts.map(({ key, label }) => (
        <li key={key}>
          <Button
            as="button"
            variant="tertiary"
            iconProps={{ size: 24, icon: 'repeat', weight: 'regular' }}
            onClick={() => {
              setLayout(layout === key ? null : key);
              onClose();
            }}
            className={styles.Button}
          >
            <Text as="span">{label}</Text>
          </Button>
        </li>
      ))}
    </>
  );
}
